import * as Msal from 'msal';
import { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import { Environment } from '../model/Environment';

let environment = Environment.DEV;
let subdomain = 'dev';
let account;
let signUpSignInAuth;
let forgotPasswordAuth;
let clientId;
let b2cScopes;
let telemetryInstrumentationKey;
let authorityDomain;
const hostname = window && window.location && window.location.hostname;

// Config for localhost
if (hostname === 'localhost' || hostname === 'alasdia-uscu-dev-diawebapps.azurewebsites.net' || hostname === 'datainsights-dev.alas.com') {
    // DEV config
    environment = Environment.DEV;
    signUpSignInAuth = 'https://alasb2cdevqa.b2clogin.com/alasb2cdevqa.onmicrosoft.com/B2C_1A_RD_USERSIGNIN_DATAINSIGHTS';
    //signUpSignInAuth = 'https://alasb2cdevqa.b2clogin.com/tfp/alasb2cdevqa.onmicrosoft.com/B2C_1A_signup_signin_dataview/';
    forgotPasswordAuth = 'https://alasb2cdevqa.b2clogin.com/tfp/alasb2cdevqa.onmicrosoft.com/B2C_1A_PasswordReset/';
    clientId = '89396790-3bd5-490e-985a-68e6a17cb319';
    b2cScopes = ['https://alasb2cdevqa.onmicrosoft.com/f753d699-c023-4cca-8c8e-228a808f89fb/DIAWebApps.Read'];
    telemetryInstrumentationKey = '710a4b41-ab70-4a1f-829c-a3fbbff40b5d';
    subdomain = 'dev';
    account = `alasdiauscudev`;
    authorityDomain = 'alasb2cdevqa.b2clogin.com';
} else if (hostname === 'alasdia-uscu-test-diawebapps.azurewebsites.net' || hostname === 'datainsights-test.alas.com') {
    // Test config 
    environment = Environment.Test;
    signUpSignInAuth = 'https://ALASB2CDev.b2clogin.com/ALASB2CDev.onmicrosoft.com/B2C_1A_RD_USERSIGNIN_DATAINSIGHTS';
    // signUpSignInAuth = 'https://ALASB2CDev.b2clogin.com/tfp/ALASB2CDev.onmicrosoft.com/B2C_1A_signup_signin_test_dataview/';
    forgotPasswordAuth = 'https://ALASB2CDev.b2clogin.com/tfp/ALASB2CDev.onmicrosoft.com/B2C_1A_PasswordReset/';
    clientId = 'a1e7d4b9-e080-48db-9a4c-1e9659e7fe6a';
    b2cScopes = ['https://ALASB2CDev.onmicrosoft.com/a5e4e417-17a9-4242-8ce9-78b118bb156c/DIAWebApps.Read'];
    telemetryInstrumentationKey = '8398e44c-6475-4afb-b5b5-8cc563ca1e5b';
    subdomain = 'staging';
    account = `alasdiauscutest`;
    authorityDomain = 'ALASB2CDev.b2clogin.com';
} else if (hostname === 'alasdia-uscu-demo-diawebapps.azurewebsites.net' || hostname === 'datainsights-demo.alas.com') {
    // Demo config
    environment = Environment.DEMO;
    signUpSignInAuth = 'https://ALASB2CDev.b2clogin.com/ALASB2CDev.onmicrosoft.com/B2C_1A_RD_USERSIGNIN_DATAINSIGHTS';
    // signUpSignInAuth = 'https://ALASB2CDev.b2clogin.com/tfp/ALASB2CDev.onmicrosoft.com/B2C_1A_signup_signin_test_dataview/';
    forgotPasswordAuth = 'https://ALASB2CDev.b2clogin.com/tfp/ALASB2CDev.onmicrosoft.com/B2C_1A_PasswordReset/';
    clientId = '58b45473-bc9c-48e5-89b8-9c335dc5e6bb';
    b2cScopes = ['https://ALASB2CDev.onmicrosoft.com/a5e4e417-17a9-4242-8ce9-78b118bb156c/DIAWebApps.Read'];
    telemetryInstrumentationKey = 'ca4ff1ba-10e8-4054-8dd0-88d51d9169b6';
    subdomain = 'demo';
    account = `alasdiauscudemo`;
    authorityDomain = 'ALASB2CDev.b2clogin.com';
} else if (hostname === 'alasdia-uscu-prd-diawebapps.azurewebsites.net' || hostname === 'datainsights.alas.com') {
    // PROD config
    environment = Environment.PROD;
    signUpSignInAuth = 'https://ALASB2CProd.b2clogin.com/ALASB2CProd.onmicrosoft.com/B2C_1A_RD_USERSIGNIN_DATAINSIGHTS';
    // signUpSignInAuth = 'https://ALASB2CProd.b2clogin.com/tfp/ALASB2CProd.onmicrosoft.com/B2C_1A_signup_signin_dataview/';
    forgotPasswordAuth = 'https://ALASB2CProd.b2clogin.com/tfp/ALASB2CProd.onmicrosoft.com/B2C_1A_PasswordReset/';
    clientId = '62daba02-1f90-4634-bc05-3ee72a938785';
    b2cScopes = ['https://alasb2cprod.onmicrosoft.com/f655bdda-f84b-412e-abb9-d1b3dcc5f97a/DIAWebApps.Read'];
    telemetryInstrumentationKey = '6564cbd3-161f-4cf6-b6b3-d4ec5f0d56c0';
    subdomain = 'www';
    account = `alasdiauscuprd`;
    authorityDomain = 'ALASB2CProd.b2clogin.com';
} else {
    throw 'Environment not implemented: ' + hostname;
}

export const authorities = {
    signUpSignIn: {
        authority: signUpSignInAuth
    },
    forgotPassword: {
        authority: forgotPasswordAuth
    }
}

export const msalConfig = {
    auth: {
        validateAuthority: false,
        clientId: clientId,
        authority: authorities.signUpSignIn.authority,
        scope: b2cScopes,
        postLogoutRedirectUri: `https://${hostname}`,
        // redirectUri: 'http://localhost:3000'
        knownAuthorities: [authorityDomain]
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

const msalInstance = new PublicClientApplication(msalConfig);
// msalInstance is a singleton and only initialize once.
export const msalInstanceReady = msalInstance.initialize().then(() => msalInstance);

// request to signin - returns an idToken
export const loginRequest = {
    scopes: ["openid", "profile"],
};

// request to acquire a token for resource access with account
export const getTokenRequest = (account: AccountInfo) => {
    return {
        scopes: msalConfig.auth.scope, // Make sure this is an array of strings
        account: account
    };
};

// request to acquire a token for resource access
export const tokenRequest = {
    scopes: msalConfig.auth.scope
};
//Application insight instrumentation key
export const Telemetry_Instrumentation_Key = telemetryInstrumentationKey;

// Enter your storage appService name and shared key
export const azureAccount = account;
export const Subdomain = subdomain;
export const appEnvironment = environment;